"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryApi = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
class CountryApi extends app_1.BaseApi {
    constructor(config) {
        super(config);
    }
    // Load countries from location api - GET /api/danfoss-location/countries
    loadCountries() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.getData();
        });
    }
    // Load translated country from location api - GET /api/danfoss-location/countries?language={uk}
    loadTranslatedCountries(languageCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                language: languageCode,
            };
            return this.getData(params);
        });
    }
    // Extended from BaseApi
    callApi(url, params) {
        const urlWithParams = this.buildUrl(url);
        return super.callApi(urlWithParams, params);
    }
    buildUrl(url) {
        return `${url}${CountryApi.API_PATH}`.replace(/([^:]\/)\/+/g, '$1');
    }
}
exports.CountryApi = CountryApi;
CountryApi.COUNTRY_PREFIX = 'countryCode';
CountryApi.API_PATH = '/danfoss-location/countries';
